import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BaseTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  .head {
    padding: 12px;
    color: #549a9a;
    background-color: #f2f2f2;
    border-radius: 50px 50px 0 0;
  }

  th {
    padding: 12px;
  }

  td {
    border-left: 1px solid #dadee5;
    padding: 8px;

    /* adds a right border to the last column */
    &:last-child {
      border-right: 1px solid #dadee5;
    }
  }
`;

export const Table = ({ children }) => {
  return <BaseTable>{children}</BaseTable>;
};

Table.propTypes = {
  children: PropTypes.node.isRequired,
};
